import TabPage from "./../../factories/tab-page";
import signatureDialogTemplate from "./signature-dialog-template.html";
import takePictureDialogTemplate from "./take-picture-dialog-template.html";
import "./../bindings/sign";
import "./../../bindings/bao-upload";
import "./../../bindings/bao-date-time-box";
import "./../../bindings/bao-date-time-picker";
import * as ko from "knockout";
import * as $ from "jquery";
import Bao from "./../../services/bao-service";
import BaoMenu from "./../../services/bao-menu";
import BaoDialog, { DialogButton } from "./../../factories/bao-dialog";
import baoRouter from "./../../services/bao-router";
import * as moment from "moment";
import Guid from "./../../factories/guid";
import SignotecWrapper from "./../services/signotec-wrapper";
import TakePictureDialog from "./../view-models/dialogs/take-picture-dialog";

/** ViewModel for the signature dialog where you can (if visible) set date and name for the signer */
export interface DialogViewModel {
    DateVisible: boolean;
    NameVisible: boolean;
    DateValue: KnockoutObservable<string>;
    NameValue: KnockoutObservable<string>;
    UsernameReadOnly: boolean;
    PickerMode: string;
}

class JsManager {
    constructor(private TabPage: TabPage) {
    }

    OpenSignDialog = (relatedField, matchcodeDate, matchcodeName, autocompleteName, enableTime, usernameReadonly) => {
        var dialogVM: DialogViewModel = this.CreateViewModelData(matchcodeDate, matchcodeName, autocompleteName, enableTime, usernameReadonly);
        SignotecWrapper.Open(dialogVM).then((result) => {
            if (result.Result === true) {
                // Set Date to current Date:
                if(Bao.Utils.String.IsNullOrEmpty(result.DateValue)) {
                    result.DateValue = (moment(new Date())).format(Bao.Utils.DateTimeFormat);
                }

                // Get Name from current logged on user:
                if(Bao.Utils.String.IsNullOrEmpty(result.NameValue)) {
                    let currentUser = this.GetUser();
                    if (currentUser != null) {
                        result.NameValue = currentUser.Username + ' (' + currentUser.Firstname + ' ' + currentUser.Lastname + ')';
                    }
                }

                // Trigger Sign Dialog Callback:
                this.TriggerSignDialogCallback(relatedField, matchcodeDate, matchcodeName, result.Data, result.NameValue, result.DateValue);
            }
            else {
                this.OpenSignDialogNormal(dialogVM, relatedField, matchcodeDate, matchcodeName, autocompleteName, enableTime, false);
            }
        });
    };

    private OpenSignDialogNormal = (dialogVM: DialogViewModel, relatedField, matchcodeDate, matchcodeName, autocompleteName, enableTime, usernameReadonly) => {
        var signDialog = this.CreateSignDialog(dialogVM, relatedField, matchcodeDate, matchcodeName);
        if (Bao.Utils.String.IsNullOrEmpty(dialogVM.DateValue())) {
            signDialog.ViewModel().DateValue(moment().format(Bao.Utils.DateTimeFormat));
        }
        $(signDialog.ViewModel().FirstElement()).parent().css("overflow", "visible"); //fix for dialog control
    };

    private TriggerSignDialogCallback(relatedField: string, matchcodeDate: string, matchcodeName: string, signatureBase64: string, nameValue?: string, dateValue?: string) {
        try {
            let additonalParameters = { matchcodeDate: matchcodeDate, matchcode: matchcodeName }
            var dateVisible = matchcodeDate != null && matchcodeDate != "";
            var nameVisible = matchcodeName != null && matchcodeName != "";
            if (dateVisible && this.TabPage.ViewModel().ChecklistModel[matchcodeDate] != undefined) {
                this.TabPage.ViewModel().ChecklistModel[matchcodeDate](dateValue);
            }
            if (nameVisible && this.TabPage.ViewModel().ChecklistModel[matchcodeName] != undefined) {
                this.TabPage.ViewModel().ChecklistModel[matchcodeName](nameValue);
            }
            this.TriggerChecklistMethod("SignDialogCallback", JSON.stringify({ Field: relatedField, Value: signatureBase64 }), additonalParameters);
        }
        catch (e) {
            this.log(e);
        }
    }
    private log(m: string) {
        //todo
    }
    /**
     * obsolete - due to backward compatibility here
     * **/
    OpenSignSignotecDialog = (relatedField) => {
        this.OpenSignDialog(relatedField, null, null, null, null, null);
    };
    Save = (jsonString) => {
        let def = $.Deferred();
        this.TabPage.IsLoading(true);
        let evaluationId = JSON.parse(jsonString).EvaluationId;
        Bao.post("Checkware/ChecklistManager/Save", JSON.stringify({ jsonModel: jsonString }), (result) => {
            this.TabPage.IsLoading(false);
            if (result === "deleted") {
                this.TabPage.$TabController.RemoveTab(this.TabPage);
                def.resolve();
            }
            else {
                this.TabPage.ViewModel().ChecklistModel.DirtyFlag(false);
                this.Refresh().then(() => {
                    def.resolve();
                });
            }
        });
        return def.promise();
    };
    ExportPdf = (evaluationId, html) => {
        this.TabPage.IsLoading(true);
        if (typeof evaluationId === "function") {
            evaluationId = evaluationId();
        }
        return Bao.post("Checkware/ChecklistManager/ExportPdf", JSON.stringify({ evaluationId: evaluationId, html: html }), (result) => {
            this.TabPage.IsLoading(false);
            if (result != null) {
                baoRouter.setHash("document/" + result);
            }
        });
    };
    SetIsDirty = (newValue) => {
        this.TabPage.DirtyFlag(newValue);
    };
    CompleteChecklist = (jsonString, html) => {
        if (this.TabPage.ViewModel().ChecklistModel.CompleteDate() == null) {
            this.TabPage.IsLoading(true);
            Bao.post("Checkware/ChecklistManager/CompleteChecklist", JSON.stringify({ jsonModel: jsonString, html: html }), (result) => {
                if (result.Result == false) {
                    this.TabPage.IsLoading(false);
                    new BaoDialog(Bao.Session.ApplicationName, result.Message, "info");
                }
                else {
                    this.TabPage.ViewModel().IsCompleted(true);
                    this.TabPage.ViewModel().ChecklistModel.CompleteChecklistSuccessfull(result);
                    this.TabPage.ViewModel().ChecklistModel.DirtyFlag(false);
                    this.TabPage.IsLoading(false);
                    var BaoMenu = window.baorequire("Services/baoMenu");
                    BaoMenu.permissionEnable({
                        ActionKey: "EvaluationSave", Enabled: !(this.TabPage.ViewModel().ChecklistModel.CompleteDate != null &&
                            this.TabPage.ViewModel().ChecklistModel.CompleteDate() != null), Context: this.TabPage.Context()
                    });
                    Bao.raiseEvent('checkware-tasks:refresh', null);
                    this.CompleteChecklistDone(true);
                }
            });
        }
    };
    private get viewModel() {
        return this.TabPage.ViewModel();
    }
    Refresh(isNew: boolean = false) {
        return Bao.post("Checkware/ChecklistManager/Load", JSON.stringify({
            checklistId: this.viewModel.ChecklistId(),
            evaluationId: this.viewModel.EvaluationId()
        }), (loadResult) => {
            if (this.viewModel.ChecklistModel != null) {
                this.viewModel.ChecklistModel.Init(JSON.stringify(loadResult), isNew);
                this.viewModel.ChecklistModel.CompleteDate(loadResult.CompleteDate);
            }
            BaoMenu.permissionEnable({ ActionKey: "EvaluationSave", Enabled: this.viewModel.SaveAllowedCheck(), Context: this.TabPage.Context() });
            this.TabPage.IsLoading(false);
        });
    }
    CompleteChecklistDone = (success) => {
        //Event dummy / Web specific
    };
    TriggerChecklistMethod = (methodName, json, additonalParameters = {}) => {
        return this.TabPage.ViewModel().ChecklistModel[methodName](json, additonalParameters);
    };
    AddAttachment = (matchcode, multifile) => {
        const self = this;
        const evaluationId = ko.unwrap(this.viewModel.EvaluationId);
        const uploadDialog = new BaoDialog('Attachment');
        uploadDialog.Width('450px');
        this.TabPage.IsLoading(true);
        uploadDialog.Buttons([
            new BaoDialog.ButtonFactory(uploadDialog, Bao.Session.GetMessage("msgOk"), () => {
                let additonalParameters = {
                    matchcode: matchcode
                }
                uploadDialog.IsLoading(true);
                $.when(uploadDialog.ViewModel().Upload()).then(() => {
                    var selectedFiles = uploadDialog.ViewModel().SelectedFiles();
                    if (selectedFiles != null && selectedFiles.length > 0) {
                        const attachmentIds = uploadDialog.ViewModel().AttachmentIds();
                        const attachments = attachmentIds.map((id, idx) => ({ Name: selectedFiles[idx], EvaluationValueId: id }));
                        this.TriggerChecklistMethod('AddAttachmentCallback', JSON.stringify({ Matchcode: matchcode, Attachments: attachments }), additonalParameters);
                    }
                    uploadDialog.IsLoading(false);
                    uploadDialog.Close();
                });
            }),
            new BaoDialog.ButtonFactory(uploadDialog, Bao.Session.GetMessage("msgCancel"), () => { uploadDialog.Close(); })
        ]);
        Bao.post("Checkware/ChecklistManager/ShowUploadAttachmentDialog", JSON.stringify({
            evaluationId: evaluationId,
            multiUpload: multifile
        }), (value) => {
            var dm = ko.map.fromJS(value.Model);
            dm.Upload = function () { };
            dm.SelectedFiles = ko.observableArray();
            dm.SelectedFiles.subscribe((newIds) => {
                let ids = [dm.AttachmentId()];
                ko.utils.arrayForEach(newIds, (id, index) => {
                    if (index > 0)
                        ids.push(Guid());
                });
                dm.AttachmentIds(ids);
            });
            dm.AttachmentIds = ko.observableArray();
            dm.UploadUrl = ko.computed(() => {
                let s = "";
                ko.utils.arrayForEach(dm.AttachmentIds(), (id) => {
                    if (s != "")
                        s = s + ";";
                    s = s + id;
                });
                return 'Checkware/ChecklistManager/UploadAttachment?attachmentIds=' + s;
            });
            uploadDialog.ViewModel(dm);
            uploadDialog.Template(value.Message);
            uploadDialog.Open();
            this.TabPage.IsLoading(false);
        });
    };
    RemoveAttachment = (matchcode, evaluationValueId) => {
        let additonalParameters = {
            matchcode: matchcode
        }
        var questionDialog = new BaoDialog(Bao.Session.ApplicationName, Bao.Session.GetMessage("msgDelete"), "question");
        questionDialog.DialogResult.subscribe((result) => {
            if (result) {
                this.TriggerChecklistMethod('RemoveAttachmentCallback', JSON.stringify({
                    Matchcode: matchcode,
                    EvaluationValueId: evaluationValueId
                }), additonalParameters);
            }
        });
    };
    DownloadAttachment = (evaluationValueId) => {
        baoRouter.setHash("document/" + evaluationValueId);
    };
    OpenDialog(html, options, callback) {
        var dialog = new BaoDialog(Bao.Session.ApplicationName, html, "info");
        if (options != null && options.width != undefined) {
            dialog.Width(options.width);
        }
        dialog.Closed = function () {
            //TODO callback raise
        };
    }
    ;
    OpenQuestionDialog(html, options, callback) {
        let additonalParameters = {}
        var questionDialog = new BaoDialog(Bao.Session.ApplicationName, html, "question");
        if (options != null && options.width != undefined) {
            questionDialog.Width(options.width);
        }
        questionDialog.DialogResult.subscribe((result) => {
            this.TriggerChecklistMethod(callback, JSON.stringify(result), additonalParameters);
        });
    }
    ;
    ShowSearch(searchObjectKey, objectValue, multiSelect, customFilter, callback, autoSearch, additonalParameters) {
        window.baorequire(["Factories/baoSearchDialog"], (baoSearchDialog) => {
            var multi = ko.unwrap(multiSelect);
            if (multi !== true && multi !== false) {
                multi = false;
            }
            var autoSearchEnabled = ko.unwrap(autoSearch);
            if (autoSearchEnabled !== true && autoSearchEnabled !== false) {
                autoSearchEnabled = false;
            }
            var searchDialogConfig = {
                ApplyItemCallback: (searchVm) => {
                    var objectKey = "SimpleSearchId";
                    var selectedItem = null;
                    if (multi) {
                        var itemIds = [];
                        var itemText = "";
                        var items = [];
                        ko.utils.arrayForEach(searchVm.Selection(), (item: any) => {
                            if (item.selected()) {
                                itemIds.push(ko.unwrap(item[objectKey]));
                                if (itemText != "") {
                                    itemText = itemText + ", ";
                                }
                                itemText = itemText + ko.unwrap(item[ko.unwrap(objectValue)]);
                                var i = ko.map.toJS(item);
                                if (i.__Root != null) {
                                    delete i.__Root;
                                }
                                items.push(i);
                            }
                        });
                        selectedItem = {
                            Text: itemText,
                            Id: JSON.stringify(itemIds),
                            Data: items
                        };
                    }
                    else {
                        selectedItem = {
                            Text: ko.unwrap(searchVm.SelectedItem()[ko.unwrap(objectValue)]),
                            Id: ko.unwrap(searchVm.SelectedItem()[ko.unwrap(objectKey)]),
                            Data: searchVm.SelectedItem()
                        };
                        if (selectedItem != null && selectedItem.Data != null && selectedItem.Data.__Root != null) {
                            delete selectedItem.Data.__Root;
                        }
                    }
                    this.TriggerChecklistMethod(callback, JSON.stringify(selectedItem), additonalParameters);
                },
                CustomFilter: JSON.parse(customFilter),
                MultiSelect: multi,
                SearchType: ko.unwrap(searchObjectKey),
                ObjectId: ko.observable(),
                ObjectValue: ko.unwrap(objectValue),
                Items: ko.observableArray(),
                AutoSearch: autoSearchEnabled
            };
            var searchDialog = new baoSearchDialog();
            searchDialog.InitSearcher(searchDialogConfig);
        });
    }
    ;
    ConnectorCall(connectorKey, methodName, parameterJson, callbackMethod) {
        Bao.post("BaoConnector/Call", JSON.stringify({ ConnectorKey: connectorKey, method: methodName, parameter: parameterJson }), (result) => {
            // TODO: Netzwerkfehler werden derzeit vom BAO abgefangen und die Fehlermeldung mit der Nachricht des Fehlers kommt, z. B. "Not Found".                
            if (result.Success) {
                let additonalParameters = {};
                this.TriggerChecklistMethod(callbackMethod, JSON.stringify({ connectorKey: connectorKey, methodName: methodName, parameterJson: parameterJson, result: result.Result }), additonalParameters);
            }
            else {
                new BaoDialog(Bao.Session.ApplicationName, result.Message, "info");
            }
        });
    }
    ;
    DownloadFile = (key) => {
        Bao.post("Checkware/ChecklistManager/GetDownloadFileResourceId", JSON.stringify({
            key: key
        }), (resourceId) => {
            if (resourceId) {
                baoRouter.setHash("document/" + resourceId);
            }
        });
    };
    TakePicture = (matchCode, caption) => {
        if (typeof (matchCode) == 'function') {
            this.openEditPictureDialog(matchCode, { base64: "", caption: caption });
        } else {
            this.openEditPictureDialog(this.TabPage.ViewModel().ChecklistModel[matchCode], { base64: "", caption: caption });
        }
    };
    EditPicture = (observable, item) => {
        this.openEditPictureDialog(observable, item);
    };
    private openEditPictureDialog = (observable: any, item: any) => {
        let takePictureDialog = new BaoDialog(Bao.Session.ApplicationName, takePictureDialogTemplate);
        let alertDialog = new BaoDialog(Bao.Session.ApplicationName, Bao.Session.GetMessage("msgIfUserDidNotClickedCaptureImage"), "info")
        alertDialog.Buttons([
            new BaoDialog.ButtonFactory(alertDialog, Bao.Session.GetMessage("msgOk"), () => {

                alertDialog.Close();
            })]);
        alertDialog.Close();
        takePictureDialog.ViewModel(new TakePictureDialog());
        takePictureDialog.Open();
        takePictureDialog.Buttons([
            new BaoDialog.ButtonFactory(takePictureDialog, Bao.Session.GetMessage("msgCancel"), () => {
                takePictureDialog.Close();
                alertDialog.Close();

            }),
            new BaoDialog.ButtonFactory(takePictureDialog, Bao.Session.GetMessage("msgOk"), () => {
                alertDialog.Close();

                if (!takePictureDialog.ViewModel().CameraOn() && (takePictureDialog.ViewModel().PictureCopy === undefined || takePictureDialog.ViewModel().PictureCopy === '')) {
                    takePictureDialog.Close();
                    return;
                }
                else if ((takePictureDialog.ViewModel().PictureCopy === undefined || takePictureDialog.ViewModel().PictureCopy === '')) {
                    alertDialog.Open();
                }
                else {
                    var base64 = takePictureDialog.ViewModel().Canvas.toDataURL('image/jpeg', 1.0);
                    if (!item.base64) {
                        item.base64 = base64;
                        observable.push(item);
                    }
                    else {
                        observable.replace(item, { base64: base64, caption: item.caption });
                    }
                    alertDialog.Close();
                    takePictureDialog.Close();

                }
            })
        ]);
        takePictureDialog.ViewModel().InitDialog(item.base64 ? typeof(item.base64) == 'function' ? item.base64() : item.base64 : null);
    };
    RemovePicture = (pictures: any, item) => {
        var questionDialog = new BaoDialog(Bao.Session.ApplicationName, Bao.Session.GetMessage("msgDeletePiccture"), "question");
        questionDialog.DialogResult.subscribe((result) => {
            if (result) {
                if (pictures != null && pictures().length != null && pictures().length > 0) {
                    let index: number = pictures.indexOf(item);
                    if (index > -1) {
                        pictures.splice(index, 1);
                    }
                }
            }
        });
    };
    GetUser = () => {
        return {
            UserId: ko.unwrap(Bao.Session.User.UserId),
            Username: ko.unwrap(Bao.Session.User.Username),
            Firstname: ko.unwrap(Bao.Session.User.Firstname),
            Lastname: ko.unwrap(Bao.Session.User.Lastname),
            Email: ko.unwrap(Bao.Session.User.Email),
            Language: ko.unwrap(Bao.Session.Language.Symbol)
        };
    };

    TakeLocation = (matchCode) => {
        let def = $.Deferred();
        if (navigator.geolocation) {
            navigator.geolocation.getCurrentPosition((position) => {
                const obs: KnockoutObservable<any> = this.TabPage.ViewModel().ChecklistModel[matchCode];
                if (obs != null) {
                    const positionObject: any = {};
                    if ('coords' in position) {
                        positionObject.coords = {};
                        if ('latitude' in position.coords) {
                            positionObject.coords.latitude = position.coords.latitude;
                        }
                        if ('longitude' in position.coords) {
                            positionObject.coords.longitude = position.coords.longitude;
                        }
                        if ('accuracy' in position.coords) {
                            positionObject.coords.accuracy = position.coords.accuracy;
                        }
                        if ('altitude' in position.coords) {
                            positionObject.coords.altitude = position.coords.altitude;
                        }
                        if ('altitudeAccuracy' in position.coords) {
                            positionObject.coords.altitudeAccuracy = position.coords.altitudeAccuracy;
                        }
                        if ('heading' in position.coords) {
                            positionObject.coords.heading = position.coords.heading;
                        }
                        if ('speed' in position.coords) {
                            positionObject.coords.speed = position.coords.speed;
                        }
                    }
                    if ('timestamp' in position) {
                        positionObject.timestamp = position.timestamp;
                    }
                    obs(JSON.stringify(positionObject));
                    def.resolve();
                }
            }, () => {
                new BaoDialog(Bao.Session.ApplicationName, Bao.Session.GetMessage("msgGeoLocationPermissionDenied"), "info");
                def.reject();
            });
        } else {
            new BaoDialog(Bao.Session.ApplicationName, Bao.Session.GetMessage("msgGeoLocationNotSupported"), "info");
            def.reject();
        }

        def.promise();
    }

    private CreateSignDialog = (dialogVM: DialogViewModel, relatedField, matchcodeDate, matchcodeName) => {
        var signDialog = new BaoDialog("Checkware")
        signDialog.Open();
        // create viewmodel
        signDialog.ViewModel(this.InitializeSignDialogViewModel(dialogVM));
        signDialog.ViewModel().signitureInitialized = function (jSinature) {
            jSinature.find("canvas").get(0).getContext("2d").strokeStyle = "#000";
            if (jSinature == null)
                return;

            jSinature.bind('change', function (e) {
                var d = $(e.target).jSignature("getData", "native");
                if (d.length > 0) {
                    signDialog.Buttons()[0].Enabled(true);
                }
            });
        }

        // create buttons
        signDialog.Buttons(this.CreateSignDialogButtons(signDialog, relatedField, matchcodeDate, matchcodeName));
        signDialog.Width("600px");
        signDialog.Template(signatureDialogTemplate);
        return signDialog;
    }
    private InitializeSignDialogViewModel = (data: DialogViewModel) => {
        return {
            fn: () => { },
            Bao: Bao,
            DateVisible: data.DateVisible,
            NameVisible: data.NameVisible,
            DateValue: data.DateValue,
            NameValue: data.NameValue,
            FirstElement: ko.observable(),
            DateInput: ko.observable(),
            PickerMode: ko.observable(data.PickerMode),
            UsernameReadonly: ko.observable(data.UsernameReadOnly),
            signitureInitialized: () => { }
        };
    }
    private CreateSignDialogButtons = (signDialog: BaoDialog, relatedField, matchcodeDate, matchcodeName): DialogButton[] => {
        let dialogButtons: DialogButton[] = [];
        let okButton = new BaoDialog.ButtonFactory(signDialog, Bao.Session.GetMessage("msgOk"), () => {
            var fn = signDialog.ViewModel().fn;
            var data = fn("getData");
            var dateValue = null;
            var nameValue = null;
            if (signDialog.ViewModel().DateVisible) {
                dateValue = signDialog.ViewModel().DateValue();
            }
            if (signDialog.ViewModel().NameVisible) {
                nameValue = signDialog.ViewModel().NameValue();
            }
            if(Bao.Utils.String.IsNullOrEmpty(dateValue)) {
                dateValue = (moment(new Date())).format(Bao.Utils.DateTimeFormat);
            }
            if(Bao.Utils.String.IsNullOrEmpty(nameValue)) {
                let currentUser = this.GetUser();
                if (currentUser != null) {
                    nameValue = currentUser.Username + ' (' + currentUser.Firstname + ' ' + currentUser.Lastname + ')';
                }
            }

            this.TriggerSignDialogCallback(relatedField, matchcodeDate, matchcodeName, data, nameValue, dateValue);
            signDialog.Close();
        });
        okButton.Enabled = ko.observable(false);
        dialogButtons.push(
            okButton,
            new BaoDialog.ButtonFactory(signDialog, Bao.Session.GetMessage("msgResetSignature"), () => {
                signDialog.ViewModel().fn("clear");
                okButton.Enabled(false);
            }),
            new BaoDialog.ButtonFactory(signDialog, Bao.Session.GetMessage("msgCancel"), () => {
                signDialog.Close();
            })
        );
        return dialogButtons;
    }

    /**
     * Creates the signature dialog viewmodel based on the passed data from the checklist / kernel
     *
     * @param matchcodeDate - The checklist matchcode for the date. If given and existing on the checklistmodel the corresponding date input is visible.
     * @param matchcodeName - The checklist matchcode for the (user)name. If give and existing on the checklistmodel the corresponding name input is visible.
     * @param autocompleteName - If true, sets the current user as default value.
     * @param enableTime - If true, pickerMode is set to 'datetime' which also shows the time.
     * @param usernameReadonly - Controls whether the username can be changed or not.
     * @returns - ViewModel for signature dialog. 
     */
    protected CreateViewModelData = (matchcodeDate, matchcodeName, autocompleteName, enableTime, usernameReadonly) : DialogViewModel => {
        var dateVisible = matchcodeDate != null && matchcodeDate != "";
        var nameVisible = matchcodeName != null && matchcodeName != "";
        let nameValue = ko.observable("");
        let dateValue = ko.observable("");
        if (nameVisible && this.TabPage.ViewModel().ChecklistModel[matchcodeName] != undefined) {
            nameValue(this.viewModel.ChecklistModel[matchcodeName]() || "");
        }
        if (dateVisible && this.TabPage.ViewModel().ChecklistModel[matchcodeDate] != undefined) {
            dateValue(this.viewModel.ChecklistModel[matchcodeDate]() || "");
        }
        if (autocompleteName) {
            nameValue(Bao.Session.User.FullName());
        }
        let readonly = false;
        if (usernameReadonly) {
            readonly = true;
        }
        let pickerMode = "date";
        if (enableTime) {
            pickerMode = "datetime";
        }
        return {
            DateVisible: dateVisible,
            NameVisible: nameVisible,
            DateValue: dateValue,
            NameValue: nameValue,
            UsernameReadOnly: readonly,
            PickerMode: pickerMode
        };
    }
    /**
   * Display the Geo location detail in the dialog
   * @param matchCode
   */
    ViewGeoLocation = (matchCode) => {
        let geoLocationDialog = new BaoDialog(Bao.Session.ApplicationName);
        if (this.viewModel.ChecklistModel[matchCode]() !== null) {
            geoLocationDialog.Template("<span style='word-break: break-word;'>" + (this.viewModel.ChecklistModel[matchCode]()) + "</span>");
        }
        geoLocationDialog.Open();
        geoLocationDialog.Buttons([
            new BaoDialog.ButtonFactory(geoLocationDialog, Bao.Session.GetMessage("msgOk"), () => {
                geoLocationDialog.Close();
            })
        ]);
    }
}
export default JsManager;


